export enum DisplayTypeEnum {
  list = 0,
  grid = 1
}
